<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container ">

    <ngb-alert *ngIf="alert" [type]="alert.type" (closed)="closeAlert()" class="sticky-top" style="top: 10px;">{{ alert.message }}</ngb-alert>

    <div class="row mb-3">
      <div class="col-12">
        <h1 class="text-center mt-4" [ngClass]="{'page-title': useRebrandedLayout }">
          Phone number
        </h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">
          To change your phone number, please fill in the fields below:
        </h5>
      </div>
    </div>

    <div class="row mb-5">
      <div [ngClass]="useRebrandedLayout ? 'mx-auto mb-3 col-md-6' : 'col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3'">

        <form
          #updateTelephoneForm="ngForm"
          (ngSubmit)="save(updateTelephoneForm)"
          novalidate>
          <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div
              *ngIf="existingTelephones.mainPhoneNumber"
              class="mb-3">
              <label class="form-label" for="phoneCurrent">
                Current phone number
              </label>
              <input
                #phoneCurrent="ngModel"
                class="form-control"
                name="phoneCurrent"
                [ngModel]="existingTelephones.mainPhoneNumber"
                placeholder="Current phone number"
                readonly
                type="text">
            </div>

            <div class="mb-3">
              <label class="form-label" for="phoneNew">
                {{ existingTelephones.mainPhoneNumber ? 'New phone' : 'Phone' }} number
              </label>
              <input
                #phoneNew="ngModel"
                class="form-control"
                [class.is-invalid]="phoneNew.touched && !phoneNew.valid"
                id="phoneNew"
                name="phoneNew"
                [(ngModel)]="updatedMainPhone"
                [pattern]="validationPatterns.telephone"
                placeholder="{{ existingTelephones.mainPhoneNumber ? 'New phone' : 'Phone' }} number"
                [required]="!existingTelephones.mainPhoneNumber"
                type="text">
              <div
                *ngIf="phoneNew.errors && phoneNew.errors.required"
                class="invalid-feedback">
                {{ errorStrings.required }}
              </div>
              <div
                *ngIf="phoneNew.errors && phoneNew.errors.pattern && !phoneNew.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>

            <hr *ngIf="!useRebrandedLayout" class="my-4">

            <div
              *ngIf="existingTelephones.secondaryPhoneNumber"
              class="mb-3">
              <label class="form-label" for="phone2Current">
                Second phone number
              </label>
              <div class="input-group">
                <input
                  #phone2Current="ngModel"
                  class="form-control"
                  name="phone2Current"
                  [ngModel]="existingTelephones.secondaryPhoneNumber"
                  placeholder="Add a second phone number"
                  readonly
                  type="text">
                <button
                  class="btn btn-outline-danger"
                  type="button"
                  (click)="removeSecondaryPhoneNumber()">
                  <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
                </button>
              </div>
            </div>

            <div>
              <label class="form-label" for="phone2New">
                {{ existingTelephones.secondaryPhoneNumber ? 'New second' : 'Second' }} phone number
              </label>
              <input
                #phone2New="ngModel"
                class="form-control"
                [class.is-invalid]="phone2New.touched && !phone2New.valid"
                id="phone2New"
                name="phone2New"
                [(ngModel)]="updatedSecondaryPhone"
                [pattern]="validationPatterns.telephone"
                placeholder="{{ existingTelephones.secondaryPhoneNumber ? 'New second' : 'Second' }} phone number"
                type="text">
              <div
                *ngIf="phone2New.errors && phone2New.errors.pattern && !phone2New.errors.minlength"
                class="invalid-feedback">
                {{ errorStrings.telephoneInvalid }}
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-success text-white btn-lg mt-5"
              [ngClass]="useRebrandedLayout ? 'w-75' : 'w-100'"
              [disabled]="!updateTelephoneForm.valid || (!updatedMainPhone && !updatedSecondaryPhone && !secondaryTelephoneDeleted) || loading"
              type="submit">
              <fa-icon *ngIf="loading" [icon]="['fas', 'spinner']" [animation]="'spin'" class="me-3"></fa-icon>
              {{ loading ? 'Saving' : 'Save' }}
            </button>
          </div>

        </form>

      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a *ngIf="!redirectParams" [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
        <a
          *ngIf="redirectParams"
          [routerLink]="redirectParams.l"
          [queryParams]="redirectParams.q"
          [fragment]="redirectParams.f">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
        </a>
      </div>
    </div>
  </div>
</div>